<shared-form-view #formView
  [formGroup]="formGroup()"
  [suggestions]="{}"
  [sections]="unitTypeSections"
  [pageType]="pageType()">
</shared-form-view>
